/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plum_Vast_Wasp_TiltInputs */

const en_plum_vast_wasp_tilt = /** @type {(inputs: Plum_Vast_Wasp_TiltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete old user`)
};

const de_plum_vast_wasp_tilt = /** @type {(inputs: Plum_Vast_Wasp_TiltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete old user`)
};

/**
* | output |
* | --- |
* | "Delete old user" |
*
* @param {Plum_Vast_Wasp_TiltInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const plum_vast_wasp_tilt = /** @type {((inputs?: Plum_Vast_Wasp_TiltInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plum_Vast_Wasp_TiltInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_plum_vast_wasp_tilt(inputs)
	return de_plum_vast_wasp_tilt(inputs)
});